import React, {useEffect, useRef, useState} from 'react'
import './style.scss'
import '../../assets/style/main.css'
import CROSS_ICON from "../../assets/images/icons/x.png"
import LINE_CONNECT_ICON from '../../assets/images/icons/line-connect.png'
import NH_CONNECT_ICON from '../../assets/images/icons/nh-connect.png'
import SHIELD_ICON from '../../assets/images/icons/ShieldCheck.png'
import { EncryptedText } from '../../utils/Encryption';
import { Base_API } from '../../_actions/matcher'
import PageLoader from '../../components/PageLoader'
import { isPageLoading } from '../../components/PageLoader'

function SignIn_Connection() {
    let onceMount = useRef(true);
    
    useEffect(() => {
        if(onceMount.current)
        {
            console.log(EncryptedText('patient_data'));
            pageInit();
            onceMount.current = false; 
        }
    }, [])

    const pageInit = async() => {
        await checkCurrentURL();
        isPageLoading(false);
    }

    const checkCurrentURL = () => {
        return new Promise(async resolve => {
            let pathname = location.pathname;
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
            localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));

            resolve();
        })
    }

    const onSubmit = () => {
        location.href = `${Base_API.pathWeb}/n-health/signin/checkmember`;
    }

    return (
        <div className='sgn_connection_con'>
            <div className="nav">
                <div className="close">
                    <img src={CROSS_ICON} />     
                </div> 
            </div>

            <div className="header">
                <div className="left">
                    <img src={LINE_CONNECT_ICON} />
                </div>
                <div className="mid">
                    <div className="loading">
                    </div>
                </div>
                <div className="right">
                    <img src={NH_CONNECT_ICON} />
                </div>
            </div>

            <div className="title-wrap">
                <h2>
                    เพื่อความสะดวกในการใช้บริการ <br/> หรือลดเวลาในการกรอกข้อมูล
                </h2>
                <p>
                    กรุณากดตกลงเพื่อนุญาตให้ระบบส่งข้อมูลของท่านไปยัง N Health
                </p>
            </div>

            <div className="proof-msg">
                <img src={SHIELD_ICON} />
                <p>ข้อมูลของคุณจะได้รับการปกป้องอย่างสูงสุดตาม<span className="text-blue">นโยบายส่วนบุคคล</span>ของเรา</p>
            </div>

            <div className="submit">
                <button onClick={onSubmit}>
                    ตกลง
                </button>
            </div>

            <div className="copyright">
                <p>© All Rights Reserved. N Health. Managed <br/> by NiLECON THAILAND.</p>
            </div>

            <PageLoader />
        </div>
    )
}

export default SignIn_Connection